import { render } from "./molde_fechado.vue?vue&type=template&id=14643977"
import script from "./molde_fechado.vue?vue&type=script&lang=js"
export * from "./molde_fechado.vue?vue&type=script&lang=js"

import "./molde_fechado.vue?vue&type=style&index=0&id=14643977&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__